import { render, staticRenderFns } from "./DoExamPaperToefl.vue?vue&type=template&id=b49bf1ac&scoped=true&"
import script from "./DoExamPaperToefl.vue?vue&type=script&lang=js&"
export * from "./DoExamPaperToefl.vue?vue&type=script&lang=js&"
import style0 from "./DoExamPaperToefl.vue?vue&type=style&index=0&id=b49bf1ac&scoped=true&lang=less&"
import style1 from "./DoExamPaperToefl.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49bf1ac",
  null
  
)

component.options.__file = "DoExamPaperToefl.vue"
export default component.exports